import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material';

@NgModule({
  imports:[MatButtonModule],
  exports:[MatButtonModule],
})

export class MaterialModule {}



// WEBPACK FOOTER //
// ./src/app/material.module.ts